import { heading, text, button, image, divider, spacer, social, footerBlk, headerBar, columns, hero } from './builders'

const FOOTER = footerBlk(
  'SecureShield Insurance Co. &bull; 200 Harbor Way, Suite 1400, Boston, MA 02210<br/>' +
    'You are receiving this email because you hold an active policy with us.<br/>' +
    '<a href="{{unsubscribe_url}}" style="color:#0d7377;">Unsubscribe</a> &nbsp;|&nbsp; ' +
    '<a href="{{preferences_url}}" style="color:#0d7377;">Manage preferences</a> &nbsp;|&nbsp; ' +
    '<a href="{{privacy_url}}" style="color:#0d7377;">Privacy policy</a>',
  { backgroundColor: '#f4f6f8', color: '#6b7a8d', fontSize: '12' }
)

const TEMPLATES = [
  {
    id: 'insurance-policy-welcome',
    category: 'insurance',
    name: 'Policy Welcome + Documents',
    description: 'Welcome new policyholders and give them one-tap access to their documents.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['My Policies', 'Claims', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('You are covered and protected', '0f2c5c', 'ffffff'),
      spacer(24),
      heading('Welcome to SecureShield, $first_name', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Your coverage is confirmed and active. We are glad to have you protected. Below are the details of your new policy along with everything you need to get started.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(20),
      text(
        '<strong>Policy number:</strong> $policy_number<br/>' +
          '<strong>Status:</strong> Active<br/>' +
          '<strong>Coverage start:</strong> $renewal_date',
        {
          fontSize: '15',
          color: '#0f2c5c',
          alignment: 'center',
          lineHeight: '1.8',
          backgroundColor: '#eef3fa',
          paddingTop: '20',
          paddingBottom: '20',
          paddingLeft: '24',
          paddingRight: '24'
        }
      ),
      spacer(24),
      button('Download policy documents', '{{documents_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '34',
        buttonPaddingV: '14'
      }),
      spacer(16),
      text(
        'Keep your policy number handy for faster service. You can view or download your documents anytime from your online account.',
        { fontSize: '13', color: '#6b7a8d', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  },
  {
    id: 'insurance-renewal-reminder',
    category: 'insurance',
    name: 'Renewal Reminder',
    description: 'Remind policyholders to renew before their coverage lapses.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['My Policies', 'Renew', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('Renew and stay protected', '0d7377', 'ffffff'),
      spacer(24),
      heading('Your policy renews soon', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Hi $first_name, this is a friendly reminder that your coverage is coming up for renewal. Renew now to keep your protection uninterrupted.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(20),
      text(
        '<strong>Policy number:</strong> $policy_number<br/>' +
          '<strong>Renewal date:</strong> $renewal_date<br/>' +
          '<strong>Premium due:</strong> $premium_amount',
        {
          fontSize: '15',
          color: '#0f2c5c',
          alignment: 'center',
          lineHeight: '1.8',
          backgroundColor: '#eef3fa',
          paddingTop: '20',
          paddingBottom: '20',
          paddingLeft: '24',
          paddingRight: '24'
        }
      ),
      spacer(24),
      button('Renew now', '{{renewal_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '14'
      }),
      spacer(16),
      text(
        'Your rate is locked in until $renewal_date. Renewing early ensures there is no gap in your coverage. Questions about your renewal? Our team is here to help.',
        { fontSize: '13', color: '#6b7a8d', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  },
  {
    id: 'insurance-claim-status',
    category: 'insurance',
    name: 'Claim Status Update',
    description: 'Notify a policyholder that the status of their claim has changed.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['My Claims', 'Documents', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('We are here for your claim', '0d7377', 'ffffff'),
      spacer(24),
      heading('An update on your claim', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Hello $first_name, there has been an update to your claim. We are handling it with care and wanted to keep you informed every step of the way.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(20),
      text(
        '<strong>Claim ID:</strong> $claim_id<br/>' +
          '<strong>Policy number:</strong> $policy_number<br/>' +
          '<strong>Current status:</strong> In review<br/>' +
          '<strong>Last updated:</strong> $renewal_date',
        {
          fontSize: '15',
          color: '#0f2c5c',
          alignment: 'center',
          lineHeight: '1.8',
          backgroundColor: '#eef3fa',
          paddingTop: '20',
          paddingBottom: '20',
          paddingLeft: '24',
          paddingRight: '24'
        }
      ),
      spacer(24),
      button('View claim details', '{{claim_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '36',
        buttonPaddingV: '14'
      }),
      spacer(16),
      text(
        'If we need any additional documents from you, we will reach out directly. You can track your claim in real time from your account at any time.',
        { fontSize: '13', color: '#6b7a8d', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  },
  {
    id: 'insurance-premium-due',
    category: 'insurance',
    name: 'Premium Due / Receipt',
    description: 'Remind policyholders of an upcoming premium payment due date.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['My Policies', 'Payments', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('Keep your coverage active', '0f2c5c', 'ffffff'),
      spacer(24),
      heading('Your premium payment is due', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Hi $first_name, a payment on your policy is coming due. Paying on time keeps your coverage active and avoids any interruption.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(20),
      text(
        '<strong>Policy number:</strong> $policy_number<br/>' +
          '<strong>Amount due:</strong> $premium_amount<br/>' +
          '<strong>Due by:</strong> $due_date',
        {
          fontSize: '15',
          color: '#0f2c5c',
          alignment: 'center',
          lineHeight: '1.8',
          backgroundColor: '#eef3fa',
          paddingTop: '20',
          paddingBottom: '20',
          paddingLeft: '24',
          paddingRight: '24'
        }
      ),
      spacer(24),
      button('Pay premium now', '{{payment_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '38',
        buttonPaddingV: '14'
      }),
      spacer(16),
      text(
        'Already paid? Thank you, please disregard this reminder and consider it your receipt confirmation. To avoid future reminders, enable autopay from your account settings.',
        { fontSize: '13', color: '#6b7a8d', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  },
  {
    id: 'insurance-new-plan-offer',
    category: 'insurance',
    name: 'New Plan Offer',
    description: 'Invite policyholders to upgrade or add coverage with a warm hero.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Plans', 'Get a Quote', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('More protection for what matters most', '0d7377', 'ffffff'),
      spacer(24),
      heading('$first_name, strengthen your coverage', {
        fontSize: '25',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Life changes, and your coverage can grow with it. As a valued policyholder on $policy_number, you qualify for our enhanced protection plans at member pricing.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(20),
      text(
        '<strong>What you get with an upgrade:</strong><br/>' +
          '&bull; Higher coverage limits for greater peace of mind<br/>' +
          '&bull; Add family members and dependents<br/>' +
          '&bull; Optional accident and roadside add-ons<br/>' +
          '&bull; Priority claims handling and 24/7 support',
        {
          fontSize: '15',
          color: '#2f4a3a',
          alignment: 'left',
          lineHeight: '1.9',
          backgroundColor: '#eaf5ee',
          paddingTop: '22',
          paddingBottom: '22',
          paddingLeft: '28',
          paddingRight: '28'
        }
      ),
      spacer(24),
      button('Get a free quote', '{{quote_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '15'
      }),
      spacer(16),
      text(
        'No obligation, and your quote takes under two minutes. Your current rate stays the same unless you choose to upgrade.',
        { fontSize: '13', color: '#6b7a8d', alignment: 'center', lineHeight: '1.6', paddingLeft: '40', paddingRight: '40' }
      ),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  },
  {
    id: 'insurance-coverage-tips',
    category: 'insurance',
    name: 'Coverage Tips Newsletter',
    description: 'Three practical tips to help policyholders get more from their policy.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Tips', 'My Policies', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#0f2c5c',
        linkColor: '#dbe6f5',
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('Get more from your policy', '0f2c5c', 'ffffff'),
      spacer(24),
      heading('Three ways to make the most of your coverage', {
        fontSize: '24',
        fontWeight: '700',
        alignment: 'center',
        color: '#0f2c5c'
      }),
      spacer(8),
      text(
        'Hi $first_name, your policy $policy_number does more than you might think. Here are three simple tips to help you get the full value of your protection.',
        { fontSize: '15', color: '#40525f', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer(24),
      columns([
        [
          heading('1. Review yearly', { fontSize: '18', fontWeight: '700', alignment: 'left', color: '#0d7377' }),
          text(
            'Life events like a new home, car, or family member can change what you need. A quick annual review keeps your coverage right-sized.',
            { fontSize: '14', color: '#40525f', alignment: 'left', lineHeight: '1.6' }
          )
        ],
        [
          heading('2. Bundle to save', { fontSize: '18', fontWeight: '700', alignment: 'left', color: '#0d7377' }),
          text(
            'Combining multiple policies often unlocks a multi-policy discount and gives you one simple bill and renewal date to manage.',
            { fontSize: '14', color: '#40525f', alignment: 'left', lineHeight: '1.6' }
          )
        ]
      ]),
      spacer(20),
      text(
        '<strong>3. Keep your documents handy.</strong> Save your policy documents and claim contacts in your account so you can act fast if you ever need to file. When something happens, minutes matter.',
        {
          fontSize: '15',
          color: '#0f2c5c',
          alignment: 'left',
          lineHeight: '1.7',
          backgroundColor: '#eef3fa',
          paddingTop: '20',
          paddingBottom: '20',
          paddingLeft: '28',
          paddingRight: '28'
        }
      ),
      spacer(24),
      button('Review my coverage', '{{policy_url}}', {
        backgroundColor: '#0d7377',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '36',
        buttonPaddingV: '14'
      }),
      spacer(24),
      divider(),
      spacer(16),
      social(),
      spacer(8),
      FOOTER
    ]
  }
]

export default TEMPLATES
